import { createAction } from '@reduxjs/toolkit';

export interface PlanBroadcastAction {
    caption?: string;
    description?: string;
    accessLevel?: string;
}

export const createCall = createAction('@CALL/CREATE');
export const connectCall = createAction('@CALL/CONNECT');
export const planCall = createAction('@CALL/PLAN');
export const planBroadcast = createAction<PlanBroadcastAction>('@CALL/PLAN_BROADCAST');
export const createBroadcastForm = createAction('@CALL/BROADCAST_FORM');
